export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtros"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Estado"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tienda"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuenta"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplicar"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Limpiar todo"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleccionar estado"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleccionar tienda"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingresar número de factura"])}
}